import type { ReactElement } from 'react';
import { ComingSoonNotice, SitePageShell } from '@/shared/ui';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

interface ComingSoonPageProps {
  /** 페이지 제목(h1). */
  readonly title: string;
}

/** 아직 준비되지 않은 화면이 공유하는 자리표시 페이지 — 사이트 헤더와 푸터 사이의 준비중 안내. */
export const ComingSoonPage = ({ title }: ComingSoonPageProps): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />}>
    <ComingSoonNotice title={title} />
  </SitePageShell>
);
